import { useAttentionFocus } from "@/hooks/useAttentionFocus";
import { ATTENTION_PRIORITY, type AttentionKey } from "@/lib/orchestration/attentionOrchestrator";

/**
 * Wraps a group of secondary surfaces and fades / blurs them whenever a
 * higher-priority surface owns the screen. Pure presentation — driven by
 * the master attention orchestrator. No new polling, no realtime.
 */
export function AttentionYieldGroup({
  selfKey,
  className = "",
  children,
}: {
  selfKey: AttentionKey;
  className?: string;
  children: React.ReactNode;
}) {
  const focus = useAttentionFocus();
  const yields = focus.active && focus.key !== selfKey && focus.priority > ATTENTION_PRIORITY[selfKey];
  return (
    <div
      className={`attention-yieldable ${className}`}
      data-attention-yield={yields ? "true" : "false"}
      aria-hidden={yields || undefined}
    >
      {children}
    </div>
  );
}